import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject, timer } from 'rxjs';
import { catchError, first, map, pluck, tap } from 'rxjs/operators';

@Injectable({
   providedIn: 'root',
})
export class CurrencyConverterService {
   private url = 'https://api.exchangeratesapi.io/latest';

   base = 'TRY';
   symbols = 'GBP,USD,EUR';

   // private currSubject = new BehaviorSubject<Currencies[]>([{currency: 'EUR', value: 10}]);
   private currSubject = new ReplaySubject<Currencies>(1);
   currencies$: Observable<Currencies> = this.currSubject.asObservable();

   private clientID = '3199c082-0bb2-4e6e-88ac-60ef7ed383bd';
   private secret = 'U5cA5eR8dE4kD4kN0mO5mU1uM8gD1jS5eN7fJ8sT6rJ4mM7mJ8';

   today = new Date().toISOString().slice(0, 10);

   // private access_key = '962509ae4bd2cd4dbf81976a8d0b0302';
   // TODO: add alternative API https://finans.truncgil.com/v2/today.json

   constructor(private http: HttpClient) {

      timer(0, 1000 * 60 * 60).pipe(
         tap(val => {
            console.log(val);
            this.fetchExchangeRatesFromIsbank();
         })
      ).subscribe();

      console.log(this.today);
   }

   fetchExchangeRatesFromIsbank() {

      const url = 'https://api.sandbox.isbank.com.tr/v1/exchange-rates/?date=' + this.today;
      console.log(url);
      const options = {
         headers: {
            'x-ibm-client-id': this.clientID,
            'x-ibm-client-secret': this.secret
         }
      };
      this.http.options(url, options);
      const response = this.http.get(url, options)
         .subscribe(
            val => console.log(val)
         );



   }

   // TODO: fetch every hour
   // fetchCurrencies(): void {
   //    const fullUrl =
   //       this.url +
   //       // + '?access_key=' + this.access_key
   //       '?base=' +
   //       this.base +
   //       '&symbols=' +
   //       this.symbols;

   //    console.warn(fullUrl);
   //    // TODO: ADD ERROR HANDLING
   //    this.http.get<CurrencyResponse>(fullUrl).pipe(
   //       // first(),
   //       map((res) => {
   //          const obj = res.rates;

   //          const currObj = {
   //             EUR: {id: 14, tlValue: 1 / obj.EUR },
   //             USD: {id: 15, tlValue: 1 / obj.USD },
   //             GBP: {id: 16, tlValue: 1 / obj.GBP }
   //          };


   //          return currObj;
   //       }),

   //       tap(curs => {
   //          // console.log('fetched currencies:', curs);
   //          this.currSubject.next(curs);
   //       }),

   //       catchError(this.handleError<Currencies>('fetchCurrencies'))
   //    ).subscribe();



   // }

   convertPriceToTL(currency: string, price: number) {
      let convertedPrice: number;
      let i = 0;
      this.currencies$.pipe(
         // first(),
         // pluck(currency, 'tlValue'),
         map(val => <number>val[currency].tlValue),
         // tap(val => console.log('pluck result ', val)),

         tap(val => convertedPrice = val * price)
      ).subscribe();

      return convertedPrice;
   }

   /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
   private handleError<T>(operation = 'operation', result?: T) {
      return (error: any): Observable<T> => {
         // TODO: send the error to remote logging infrastructure
         console.error(error); // log to console instead

         // TODO: better job of transforming error for user consumption
         console.log(`${operation} failed: ${error.message}`);

         // Let the app keep running by returning an empty result.
         return of(result as T);
      };
   }
}

export interface Currencies {
   EUR: { id: number, tlValue: number },
   USD: { id: number, tlValue: number },
   GBP: { id: number, tlValue: number }

}

export interface CurrencyResponse {
   success: boolean;
   timestamp: number;
   base: string;
   date: string;
   rates: {
      GBP: number;
      USD: number;
      EUR: number;
   };
}
